import React from 'react';
import ClaimAwardSummaryCard from './components/ClaimAwardSummaryIndex.jsx';

const ClaimAwardSummary = () => <ClaimAwardSummaryCard />;

export default ClaimAwardSummary;
